<template>
  <div id="TemplateListPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-12">
        <h1 class="title">TEMPLATE LIST</h1>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline has-text-left">
        <div
          v-for="template_info in template_list"
          :key="template_info.id"
          class="column is-4-desktop is-6-tablet is-12-mobile"
        >
          <template-file-card v-bind="template_info" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateFileCard from "@/components/cards/TemplateFileCard.vue";

export default {
  name: "BalanceSheetPage",
  components: {
    TemplateFileCard
  },
  data() {
    return {
      template_list: [
        {
          id: 1,
          file_name: "Disclaimer",
          image: require("@/assets/templates/disclaimer.jpg"),
          type: "disclaimer",
          desc:
            "การให้บริการวางแผนการเงิน มีข้อตกลงชัดเจนในขอบเขตการให้บริการ และการรักษาความเป็นส่วนตัวของผู้รับการวางแผน ท่านจึงสามารถไว้วางใจในการรับการวางแผนจากเราได้อย่างสบายใจ"
        },
        {
          id: 2,
          file_name: "Client Personalized",
          image: require("@/assets/templates/client_personalized.jpg"),
          type: "personalized",
          desc:
            "ข้อมูลส่วนตัวของผู้รับการวางแผน จะถูกใช้เพื่อทำแผนการเงินในรายงานแต่ละครั้งเท่านั้น เราไม่ได้มีนโยบายเก็บข้อมูลเพื่อนำข้อมูลไปใช้ในกิจกรรมอื่นๆแต่อย่างใด ท่านจึงสามารถเปิดเผยข้อมูลที่ท่านเห็นว่าเป็นประโยชน์ต่อการวางแผนให้กับทางเราได้"
        },
        {
          id: 3,
          file_name: "Insurance Info.",
          image: require("@/assets/templates/insurance_info.jpg"),
          type: "insurance",
          desc:
            "การบริหารจัดการความเสี่ยงมีรายละเอียดมากกว่าที่ท่านคิด เราจึงขอความร่วมมือท่านให้ข้อมูลที่ละเอียดเท่าที่จะให้ได้แก่ทางทีมงาน เพื่อการวางแผนบริหารความเสี่ยงที่สมบูรณ์ของท่าน"
        }
      ]
    };
  }
};
</script>
